module.exports = __webpack_public_path__ + "img/logo.149d014e.png";